
export default {
  props: ['name']
};